import { UpcomingInvoiceI } from '@/modules/myServices/types/api/Service'
import { formatDate } from '@/utils'
import { useUserStore } from '@/modules/auth/store'

export default class UpcomingInvoiceItem {
  id: number
  invoicenum: string
  date: string
  duedate: string
  subtotal: string
  status: string
  constructor(item: UpcomingInvoiceI) {
    this.id = item.id
    this.invoicenum = item.invoicenum ?? '-'
    this.date = formatDate(item.date)
    this.duedate = formatDate(item.duedate)
    this.subtotal = item.subtotal ? `${this.userCurrency} ${item.subtotal}` : '-'
    this.status = item.status
  }

  get userCurrency() {
    return useUserStore().getUser.currency_code
  }

  get getChipsColor() {
    switch (this.status) {
      case 'Paid':
        return 'green'
      case 'Unpaid':
        return 'gray'
      default:
        return 'red'
    }
  }
}
